var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelopeGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 33 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#62686E",
  fillRule: "evenodd",
  d: "M4.014 1a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2h-22a1 1 0 0 1-1-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#62686E",
  fillRule: "evenodd",
  d: "M27.014 0a1 1 0 0 1 1 1v15h-2V1a1 1 0 0 1 1-1M30.39 31.565l-11.376-11.85 1.521-1.298 11.377 11.849zM2.014 31.565l11.377-11.85-1.521-1.298L.492 30.266zM.35 13.252 4.016 10l1.327 1.495-.843 3.753-2.822-.5A1 1 0 0 1 .35 13.253",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#62686E",
  fillRule: "evenodd",
  d: "m28 16-1.617-4.478 1.262-1.551 4 3.253a1 1 0 0 1 .145 1.407c-.348.428-3.361 1.718-3.79 1.369",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#62686E",
  fillRule: "evenodd",
  d: "M31.014 13a1 1 0 0 1 1 1v17a1 1 0 1 1-2 0V14a1 1 0 0 1 1-1",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#62686E",
  fillRule: "evenodd",
  d: "M15.079 21.011a.95.95 0 0 1 .545-1.273l15-5.659a1.05 1.05 0 0 1 1.326.568.95.95 0 0 1-.545 1.274l-15 5.658a1.05 1.05 0 0 1-1.326-.568M1.014 13a1 1 0 0 0-1 1v17a1 1 0 1 0 2 0V14a1 1 0 0 0-1-1",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#62686E",
  fillRule: "evenodd",
  d: "M16.95 21.011a1.05 1.05 0 0 1-1.326.568l-15-5.658a.95.95 0 0 1-.546-1.274 1.05 1.05 0 0 1 1.327-.568l15 5.659c.516.195.76.765.545 1.273",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#62686E",
  fillRule: "evenodd",
  d: "M5.014 0a1 1 0 0 1 1 1v15h-2V1a1 1 0 0 1 1-1M31.014 32h-30v-2h30zM13.362 8.014c-.884-.498-1.787.62-1.115 1.38l3.682 4.163a.1.1 0 0 0 .15 0l3.682-4.163c.672-.76-.23-1.878-1.115-1.38l-2.642 1.485zm-2.463 2.573c-2.017-2.28.692-5.634 3.345-4.142l1.76.99 1.76-.99c2.653-1.492 5.362 1.862 3.345 4.142l-3.682 4.163a1.9 1.9 0 0 1-2.846 0z",
  clipRule: "evenodd"
})));
export default SvgEnvelopeGrey;